import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Preset } from '../elements.types';
import {HttpClient} from "@angular/common/http";
import {ToastService} from 'ng-uikit-pro-standard';



@Component({
  selector: 'as-presets',
  templateUrl: './presets.component.html',
  styleUrls: ['./presets.component.scss']
})
export class PresetsComponent implements OnInit {

  constructor(private http: HttpClient, private toast?: ToastService) { }


  @Input() presets;
  @Input() updatedPreset; //saving this update as new preset
  @Input() filterType: string;
  @Output() preset =  new EventEmitter();


  filteredPresets: Preset[];

  model = {presetName: null }
  selectdPreset: Preset = {
    id: -1,
    name: '',
    preset: null,
    type: ''
  }
  errorMessage: any;




  ngOnInit() {
      this.getPresets();

  }

  private fetchPreset(type, callback= null){
    this.http.post('/content/getPresets', {type: this.filterType} ).subscribe((p)=>{
      this.presets = p;
      if(callback){
       return  callback();
      }
    })
  }


  public getPresets(){

     this.fetchPreset(this.filterType, ()=>{
      if(this.presets){
        this.filteredPresets = this.presets.filter((f)=>f.type == this.filterType);
      } else {
        return [];
      }
    });

   }


  updateFromPreset(event) {

    if( event.target.value != 0 ){
      this.selectdPreset = this.filteredPresets.find((p=>p.id == event.target.value));
      this.preset.emit(JSON.parse(this.selectdPreset.preset));
      this.model.presetName = null;
    }
  }

  savePreset() {

    if (this.model.presetName == null){
      this.errorMessage = "Name Required";

    } else {

      this.errorMessage  = "";

      let preset:Preset  = {
        name : this.model.presetName,
        preset : JSON.stringify( this.updatedPreset),
        type :  this.filterType
      }

      this.model.presetName = null;

      this.http.post('/content/savePreset', preset).subscribe((data)=> {

        if (data['id']){

          let p = new Preset();
          p.name = data['name'],
          p.type = data['type'],
          p.preset = data['preset'],
          p.id = data['id']

          this.toast.success('Preset Updated', 'Success', {positionClass: 'md-toast-bottom-left', toastClass: 'opaque'});
          this.filteredPresets.push(p);

          this.selectdPreset = this.filteredPresets.find((p=>p.id == data['id']));
          this.preset.emit(JSON.parse(this.selectdPreset.preset));


        } else {
          this.toast.error('Something went wrong', 'Error', {positionClass: 'md-toast-bottom-left', toastClass: 'opaque'});
        }
  })

    }

  }

}
